import React, { useState } from "react";
import { Typography } from "antd";
import styles from "./teacher-attendance.module.css";
import OverviewTeacherAttendance from "./components/overview/Overview";
import TeacherAttendanceDetails from "./components/attendance-details/Attendance-details";
import AttendanceDateChanger from "../attendance-date-changer/attendance-date-changer";
import dayjs from "dayjs";
import moment from "moment/moment";

const TeacherAttendance = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  
  const handleChangeDate = (val) => {
    let day = null;
    if (val < 0) day = moment(selectedDate).subtract(Math.abs(val), "days");
    else day = moment(selectedDate).add(val, "days");
    setSelectedDate(new Date(day));
  };

  return (
    <div className={styles.studentAttendance}>
      <div className={styles.headerContainer}>
      <Typography className={styles.title}>Overview</Typography>
        <AttendanceDateChanger
          date={dayjs(selectedDate).format("DD MMMM, YYYY ")}
          onChange={handleChangeDate}
          isNextDateDisabled={true}
        />
      </div>
      <OverviewTeacherAttendance selectedDate={dayjs(selectedDate).format("YYYY-MM-DD")} />
      <TeacherAttendanceDetails selectedDate={dayjs(selectedDate).format("YYYY-MM-DD")} />
    </div>
  );
};

export default TeacherAttendance;
